import { SVGProps } from 'react';

const IconDiscover = (props: SVGProps<SVGSVGElement>) => (
  <svg width={26} height={26} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M12.865 0C5.769 0 0 5.769 0 12.865c0 7.095 5.769 12.864 12.865 12.864 7.095 0 12.864-5.769 12.864-12.864C25.73 5.769 19.96 0 12.865 0Zm6.607 8.043-3.087 7.096a2.432 2.432 0 0 1-1.246 1.246l-7.095 3.087c-1.111.488-2.275-.65-1.76-1.76l3.06-7.122a2.433 2.433 0 0 1 1.246-1.247l7.096-3.086c1.137-.488 2.274.65 1.787 1.786Zm-6.607 6.582a1.76 1.76 0 1 0 0-3.52 1.76 1.76 0 0 0 0 3.52Z" />
  </svg>
);

export default IconDiscover;
